document.addEventListener('DOMContentLoaded', function() {
  // Grab all accordion elements
  const accordionBlocks = document.querySelectorAll('.accordion');

  accordionBlocks.forEach(accordion => {
    // Within each accordion, find the content div
    const content = accordion.querySelector('.collapsible__content.accordion__content.rte');
    
    if (content) {
      // Trim any whitespace or hidden markup
      const isEmpty = !content.textContent.trim() && !content.innerHTML.trim();

      // If truly empty, hide this specific accordion
      if (isEmpty) {
        accordion.style.display = 'none';
      }
    }
  });
});